module.exports = {
	"api": 1,
	"kp": 6,
	"dev": {
		"host": "vemsis.vyshneve.arm.kodas.co.ua",
		"wsPort": "",
		"wrtPort": ""
	},
	"prod": {
		"wsUrl": "",
		"baseUrl": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./settings.json
// module id = 313
// module chunks = 0